module.exports = __webpack_public_path__ + "static/media/9.bc92ab73.jpg";